module.exports = require('./helpers/bundle-url').getBundleURL('fsYD4') + "logo-dark.eefe0b7f.svg";